export const categories = [
  {
    slug: 'download-guide',
    name: '下载指南',
    description: '麻豆传媒app官方下载渠道、各平台下载教程及版本选择指南',
    icon: 'ri-download-2-line',
    image: 'https://readdy.ai/api/search-image?query=Modern%20smartphone%20app%20download%20interface%20with%20clean%20minimalist%20design%2C%20soft%20warm%20lighting%2C%20mobile%20phone%20screen%20showing%20download%20progress%2C%20neutral%20cream%20background%2C%20editorial%20photography%20style%2C%20high%20quality%2C%20professional%20app%20presentation&width=800&height=600&seq=cat-download&orientation=landscape',
  },
  {
    slug: 'installation-tutorial',
    name: '安装教程',
    description: '分步安装指导、权限设置说明及常见安装问题解决方案',
    icon: 'ri-install-line',
    image: 'https://readdy.ai/api/search-image?query=Smartphone%20app%20installation%20process%20shown%20on%20a%20clean%20desk%20setup%2C%20minimalist%20workspace%20with%20phone%20displaying%20installation%20screen%2C%20warm%20cream%20background%2C%20soft%20natural%20light%2C%20professional%20tutorial%20aesthetic&width=800&height=600&seq=cat-install&orientation=landscape',
  },
  {
    slug: 'usage-guide',
    name: '使用指南',
    description: '界面功能介绍、个性化设置、离线下载等核心功能使用技巧',
    icon: 'ri-book-open-line',
    image: 'https://readdy.ai/api/search-image?query=Modern%20mobile%20app%20user%20guide%20display%20with%20smartphone%20showing%20clean%20interface%20screenshots%2C%20minimalist%20flat%20lay%20composition%2C%20warm%20cream%20background%2C%20soft%20shadows%2C%20editorial%20design%20style%2C%20user-friendly%20app%20presentation&width=800&height=600&seq=cat-usage&orientation=landscape',
  },
  {
    slug: 'latest-updates',
    name: '最新动态',
    description: '版本更新日志、新功能上线通知及优化改进详情',
    icon: 'ri-news-line',
    image: 'https://readdy.ai/api/search-image?query=App%20update%20notification%20display%20on%20smartphone%20screen%20with%20clean%20interface%2C%20modern%20minimalist%20design%2C%20warm%20neutral%20background%2C%20soft%20lighting%2C%20tech%20news%20aesthetic%2C%20professional%20presentation&width=800&height=600&seq=cat-updates&orientation=landscape',
  },
  {
    slug: 'faq',
    name: '常见问题',
    description: '账号问题、播放异常、会员服务等高频问题官方解答',
    icon: 'ri-question-answer-line',
    image: 'https://readdy.ai/api/search-image?query=Frequently%20asked%20questions%20display%20on%20a%20modern%20tablet%20screen%20with%20clean%20minimalist%20layout%2C%20warm%20cream%20background%2C%20soft%20natural%20light%2C%20help%20center%20aesthetic%2C%20professional%20customer%20support%20design&width=800&height=600&seq=cat-faq&orientation=landscape',
  },
];

export const getCategoryBySlug = (slug: string) =>
  categories.find((c) => c.slug === slug);